import React, { useCallback, useContext, useMemo, useState } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { BoxClass } from '../../../helper/classes'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { hasScrollbarIfHover } from '../../../helper/CSSclasses'
import { moveForBnD, reorderForBnD } from '../../../helper/functions'
import { GlobalContext, globalOnDemandVars } from '../../../helper/context'
import DialogComp from '../../commonInterface/dialog'
import InfiniteScroll from 'react-infinite-scroll-component'
import { uniqueId } from 'lodash'
import { OneItemForType1 } from './parts/oneItemForType1'
import LoadingCover from '../../commonInterface/loadingCover'
import { updateMediaItemF } from '../../../backend/mediaItems/updateData'
import { Button, Tooltip } from '@blueprintjs/core'
import { OverlayProps, sidebarDirection, TutorialVideoConfig } from '../../../helper/configs'
import YouTube from 'react-youtube'

// const getItems = (count, location) =>
//   Array.from({ length: count }, (v, k) => k).map(k => {
//     const id = globalOnDemandVars.type1Count()
//     globalOnDemandVars.set_type1Count(id + 1)
//     return ({
//       id: id,
//       type: `item ${id}`,
//       title: 'item ' + id,
//       location: location
//     })
//   })

function UploadType1 ({ forDialog }) {
  const contextValue = useContext(GlobalContext)

  const waitingItems = contextValue.waitingItemsForType1
  const setWaitingItems = globalOnDemandVars.set_waitingItemsForType1
  const usedItems = contextValue.usedItemsForType1
  const setUsedItems = globalOnDemandVars.set_usedItemsForType1

  const [limitForWaitingItems, setLimitForWaitingItems] = useState(forDialog ? 20 : 10)
  const [limitForUsedItems, setLimitForUsedItems] = useState(forDialog ? 20 : 10)

  const onDragEnd = useCallback(
    result => {
      const { source, destination } = result

      // dropped outside the list
      if (!destination) {
        return
      }

      let sourceList, setSourceList, limit
      switch (source.droppableId) {
        case 'waiting':
          sourceList = waitingItems
          setSourceList = setWaitingItems
          limit = limitForWaitingItems
          break
        case 'used':
          sourceList = usedItems
          setSourceList = setUsedItems
          limit = limitForUsedItems
          break
        default:
          break
      }

      if (source.droppableId === destination.droppableId) {
        const items = reorderForBnD(
          sourceList,
          source.index,
          destination.index
        )
        setSourceList(items)

        const currentItems = items.slice(0, limit)
        currentItems.forEach((item, i) => {
          updateMediaItemF(item.globalId, {
            type1Order: i
          })
        })
      } else {
        let destinationList, setDestinationList
        switch (destination.droppableId) {
          case 'waiting':
            destinationList = waitingItems
            setDestinationList = setWaitingItems

            // limitForDestination = limitForWaitingItems
            // limitForSource = limitForUsedItems
            break
          case 'used':
            destinationList = usedItems
            setDestinationList = setUsedItems

            // limitForDestination = limitForUsedItems
            // limitForSource = limitForWaitingItems
            break
          default:
            break
        }

        const result = moveForBnD(
          sourceList,
          destinationList,
          source,
          destination
        )

        setDestinationList(result.destination)
        setSourceList(result.source)

        let limitForDestination, limitForSource, currentDestinationItems, currentSourceItems
        switch (destination.droppableId) {
          case 'waiting':
            limitForDestination = limitForWaitingItems
            limitForSource = limitForUsedItems
            currentDestinationItems = result.destination.slice(0, limitForDestination)
            currentSourceItems = result.source.slice(0, limitForSource)

            currentDestinationItems.forEach((item, i) => {
              updateMediaItemF(item.globalId, {
                inWaitingItemsForType1: true,
                inUsedItemsForType1: false,
                type1Order: i
              })
            })
            currentSourceItems.forEach((item, i) => {
              updateMediaItemF(item.globalId, {
                inWaitingItemsForType1: false,
                inUsedItemsForType1: true,
                type1Order: i
              })
            })
            break
          case 'used':
            limitForDestination = limitForUsedItems
            limitForSource = limitForWaitingItems
            currentDestinationItems = result.destination.slice(0, limitForDestination)
            currentSourceItems = result.source.slice(0, limitForSource)

            currentDestinationItems.forEach((item, i) => {
              updateMediaItemF(item.globalId, {
                inWaitingItemsForType1: false,
                inUsedItemsForType1: true,
                type1Order: i
              })
            })
            currentSourceItems.forEach((item, i) => {
              updateMediaItemF(item.globalId, {
                inWaitingItemsForType1: true,
                inUsedItemsForType1: false,
                type1Order: i
              })
            })
            break
          default:
            break
        }
      }
    }
    ,
    [limitForUsedItems, limitForWaitingItems, setUsedItems, setWaitingItems, usedItems, waitingItems]
  )

  const [dialogOpen, setDialogOpen] = useState(false)
  const [inDialog, setInDialog] = useState({
    title: null,
    content: null
  })
  const dialog = useMemo(() => (<DialogComp isOpen={dialogOpen} setDialogOpen={setDialogOpen} title={inDialog.title} type={'bigger'}>
    {inDialog.content}
  </DialogComp>), [dialogOpen, inDialog.content, inDialog.title])
  const setDialog = useCallback(
    (title, content) => {
      setDialogOpen(true)
      setInDialog({
        title,
        content
      })
    },
    []
  )

  // -----------------------------------------------------------------------------------------------------------

  const ids = useMemo(() => ({
    waitingDiv: uniqueId(),
    usedDiv: uniqueId()
  }), [])

  const inDroppable1 = useMemo(() => (<InfiniteScroll style={{ overflow: 'visible' }}
    next={() => {
      setLimitForWaitingItems(limitForWaitingItems + 10)
    }}
    dataLength={limitForWaitingItems}
    loader={'......'}
    hasMore={waitingItems.length > limitForWaitingItems}
    scrollThreshold='50px'
    scrollableTarget={ids.waitingDiv}
  >{waitingItems.slice(0, limitForWaitingItems).map((item, index) => {
      if (!item) {
        return null
      }
      return (
        <Draggable
          key={item.type + item.id} draggableId={item.type + item.id}
          index={index}>
          {(provided, snapshot) => (
            <div ref={provided.innerRef} {...provided.draggableProps}>
              <OneItemForType1 firstWaitingItem={index === 0} location={'waiting'}
                dragHandleProps={provided.dragHandleProps}
                item={item} setDialog={setDialog} />
            </div>
          )}
        </Draggable>
      )
    })
    }</InfiniteScroll>), [ids.waitingDiv, limitForWaitingItems, setDialog, waitingItems])

  const inDroppable2 = useMemo(() => (<InfiniteScroll style={{ overflow: 'visible' }}
    next={() => {
      setLimitForUsedItems(limitForUsedItems + 10)
    }}
    dataLength={limitForUsedItems}
    loader={'......'}
    hasMore={usedItems.length > limitForUsedItems}
    scrollThreshold='50px'
    scrollableTarget={ids.usedDiv}
  >{usedItems.slice(0, limitForUsedItems).map((item, index) => {
      if (!item) {
        return null
      }
      return (
        <Draggable key={item.type + item.id}
          draggableId={item.type + item.id}
          index={index}>
          {(provided, snapshot) => (
            <div ref={provided.innerRef} {...provided.draggableProps}>
              <OneItemForType1 location={'used'}
                dragHandleProps={provided.dragHandleProps}
                item={item} setDialog={setDialog} />
            </div>
          )}
        </Draggable>
      )
    })}</InfiniteScroll>
  ), [ids.usedDiv, limitForUsedItems, setDialog, usedItems])

  const heightNumber = useMemo(() => (forDialog ? 400 : 150), [forDialog])
  return (
    useMemo(() => (<div css={css`position: relative;`}>
      {contextValue.type1Ready ? null : <LoadingCover text={'Loading Data'} />}
      {dialog}
      <Tooltip {...OverlayProps} targetTagName={'div'} content={'Normal Upload as You Would Expect'}>
        <Button icon={'help'} fill minimal text='Help' onClick={() => {
        globalOnDemandVars.openGlobalDialog()('Upload Media (Type 1)', <YouTube
          videoId={'EbXtermgJ_A'} {...TutorialVideoConfig} />, 'bigger', true)
      }} /></Tooltip>
      <DragDropContext onDragEnd={onDragEnd}>
        <div
          css={css`display: flex; flex-wrap: wrap; justify-content: flex-start; padding-left: 10px; padding-bottom: 2px; padding-right: 2px;`}>
          <div id={'waitingItems'} css={css`max-width: 100%; position: relative;`}>
            <Tooltip {...OverlayProps} position={sidebarDirection === 'right' ? 'top-left' : 'top-right'} content={'You can insert items in this list in sequence by pressing alt + 1 while entering the node.'} ><h2 css={css`margin-left: 20px; margin-top: 10px;`}>Waiting Items</h2></Tooltip>
            <Droppable droppableId='waiting'>
              {(provided, snapshot) => (
                <div id={ids.waitingDiv}
                  ref={provided.innerRef} {...provided.droppableProps}
                  style={{
                    backgroundColor: snapshot.isDraggingOver ? 'var(--primary5)' : 'transparent'
                  }}
                  css={css`min-width: 150px; max-width: ${forDialog ? 500 : 300}px; max-height: ${heightNumber}px; overflow-y: scroll;`}
                  className={hasScrollbarIfHover + ' ' + 'bp3-card'}
                >
                  {inDroppable1}
                  {provided.placeholder}
                </div>
              )}
            </Droppable></div>
          <div id={'usedItems'} css={css`max-width: 100%; position: relative;`}>
            <Tooltip {...OverlayProps} position={sidebarDirection === 'right' ? 'top-left' : 'top-right'} content={'Used items go here, but you can drag and drop them back to Waiting Items.'}><h2 css={css`margin-left: 20px; margin-top: 10px;`}>Used Items</h2></Tooltip>
            <Droppable droppableId='used'>
              {(provided, snapshot) => (
                <div id={ids.usedDiv}
                  ref={provided.innerRef} {...provided.droppableProps}
                  style={{
                    backgroundColor: snapshot.isDraggingOver ? 'var(--primary5)' : 'transparent'
                  }}
                  css={css`min-width: 150px; max-width: ${forDialog ? 500 : 300}px; max-height: ${heightNumber}px; overflow-y: scroll;`}
                  className={hasScrollbarIfHover + ' ' + 'bp3-card'}
                >
                  {inDroppable2}
                  {provided.placeholder}</div>
              )}
            </Droppable></div>
        </div>
      </DragDropContext></div>), [contextValue.type1Ready, dialog, forDialog, heightNumber, ids.usedDiv, ids.waitingDiv, inDroppable1, inDroppable2, onDragEnd])
  )
}

const UploadType1BoxClass = new BoxClass(UploadType1, 'Upload Type 1', null, 2, { order: 1, initialHeight: 420 })

export default UploadType1BoxClass
